import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * A speech bubble with an upward-pointing stem, positioned below the orb.
 * The stem points up towards the orb, as if the orb is speaking.
 */
const SpeechBubble = ({ children, sx = {} }) => {
  return (
    <Box className="speech-bubble" sx={sx}>
      <Box className="speech-bubble__stem" />
      <Box className="speech-bubble__content">
        {typeof children === "string" ? (
          <Typography variant="body1" sx={{ margin: 0, textAlign: "center" }}>
            {children}
          </Typography>
        ) : (
          children
        )}
      </Box>
    </Box>
  );
};

export default SpeechBubble;
